import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getCategory } from "../../../../services/InventoryAPI";
import { useParams } from "react-router-dom";

const ModalCategoryFilter = ({
  open,
  setOpen,
  listId,
  setListId,
  setType,
  offset,
}) => {
  const { status } = useParams();
  const [tempArr, setTempArr] = useState([]);

  const { data: categories, isFetching } = useQuery({
    queryKey: ["category", offset],
    queryFn: () => getCategory(1000, offset, status),
  });

  const handleSelectList = useCallback(
    (selectedId) => {
      var temp = [...tempArr];
      const index = temp.findIndex((id) => id === selectedId);
      setTempArr(
        index < 0
          ? [...tempArr, selectedId]
          : [...tempArr.slice(0, index), ...tempArr.slice(index + 1)]
      );
    },
    [tempArr]
  );

  useEffect(() => {
    if (open) setTempArr(listId);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Kategori
        {tempArr.length > 0 ? (
          <Button
            variant="contained"
            sx={{ marginLeft: 1 }}
            onClick={() => {
              setOpen(false);
              setListId(tempArr);
              setType("category");
            }}
          >
            Cari
          </Button>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table sx={{ width: "100%" }} aria-label="simple table">
            <TableBody>
              {categories && categories !== undefined && !isFetching ? (
                <>
                  {categories.map((category) => (
                    <TableRow
                      key={category.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="label"
                        sx={{ paddingY: 0 }}
                      >
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              checked={tempArr.includes(category.id)}
                              onChange={() => {
                                handleSelectList(category.id);
                              }}
                            />
                          }
                          label={category.name}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : isFetching ? (
                <CircularProgress size={20} />
              ) : (
                "Tidak ada kategori"
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default ModalCategoryFilter;
